import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getServicePrimaryTagList } from "../api/getServicePrimaryTagList";

export const QUERY_KEY = "servicePrimaryTag";

export const useServicePrimaryTagListQuery = () => {
  return useQuery({
    queryKey: [QUERY_KEY],
    queryFn: async () => {
      return getServicePrimaryTagList();
    },
  });
};

export const invalidateServicePrimaryTagListQuery = () => {
  return queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
};
